import React from "react";
import { useDispatch } from "react-redux";
import { Box, Grid, Link, ListItemIcon, Tooltip, Fade } from "@material-ui/core";
import PostAddIcon from "@material-ui/icons/PostAdd";
import { GridRowModel } from "@mui/x-data-grid-premium";
import { useFormik } from "formik";
import moment from "moment";
import { searchData, downloadFile, sendEmailRequest } from "src/app-redux/common-actions";
import { useAppSelector } from "src/app-redux/hooks";
import { getOrderStatusAction } from "src/app-redux/work-order/actions/workorderActions";
import { selectOrderStatus } from "src/app-redux/work-order/workOrderSlice";
import { getLocalDateTime, getTimezoneName, setDateTimeFormate } from "src/common/utils/app.util";
import UseWindowDimensions from "src/common/utils/getWindowDimensions";
import { moneyformatter } from "src/common/utils/helpers";
import CommonAutoCompleteField from "src/components/CommonAutoCompleteField/CommonAutoCompleteField";
import CommonButton from "src/components/CommonButton/CommonButton";
import CommonDataGridPage from "src/components/CommonDataGridPage/CommonDataGridPage";
import CommonTextField from "src/components/CommonTextField/CommonTextField";
import CommonTextFieldDate from "src/components/CommonTextFieldForDate/CommonTextFieldDate";
import CommonXGrid from "src/components/CommonXGrid/CommonXGrid";

export const columns = [
  // {
  //   field: "ordNum",
  //   headerName: "WO #",
  //   type: "string",
  //   width: 150,
  // },
  {
    field: "poNum",
    headerName: "PO #",
    type: "string",
    width: 150,
    editable: false,
    renderCell: function customCell(params: any) {
      return (
        <Link
          component="button"
          variant="body2"
          onClick={(e: any) => {
            e.stopPropagation();
            const win: any = window.open(
              `/work-order/work-order-details/${params.row.ocdId}/${params.row.ordNum}/${params.row.crewId}`,
              "_blank"
            );
            win?.focus();
          }}
        >
          {params.value}
        </Link>
      );
    },
  },
  {
    field: "clientCode",
    headerName: "Client",
    type: "string",
    width: 150,
  },
  {
    field: "location",
    headerName: "Location ID",
    type: "string",
    width: 150,
  },
  {
    field: "city_state",
    headerName: "City, State",
    type: "string",
    width: 160,
  },
  // {
  //   field: "state",
  //   headerName: "State",
  //   type: "string",
  //   width: 150,
  // },
  {
    field: "orderType",
    headerName: "Order Type",
    type: "string",
    width: 170,
  },
  {
    field: "nte",
    headerName: "NTE",
    type: "number",
    width: 110,
    valueFormatter: (params: any) => {
      if (!params.value) {
        return params.value;
      }
      return moneyformatter(params.value);
    },
  },
  {
    field: "orderStatus",
    headerName: "WO Status",
    type: "string",
    width: 180,
  },
  {
    field: "clientPO",
    headerName: "Client PO",
    type: "string",
    width: 150,
  },
  {
    field: "workDate",
    headerName: "Work Date",
    type: "dateTime",
    width: 150,
    valueFormatter: (params: any) => {
      if (!params.value) {
        return params.value;
      }
      return getLocalDateTime(params.value, "MM/DD/YYYY hh:mm A");
    },
  },
  {
    field: "icons",
    headerName: "",
    type: "string",
    width: 100,
    renderCell: function customCell(params: any) {
      return (
        <ListItemIcon>
          {params.row.signOffExist ? (
            <Tooltip
              TransitionComponent={Fade}
              TransitionProps={{ timeout: 600 }}
              title={"SignOff Exist"}
              arrow
              placement="top"
            >
              <PostAddIcon style={{ fill: "red" }} />
            </Tooltip>
          ) : (
            <PostAddIcon color="disabled" />
          )}
          {params.row.vendorInvoiceExist ? (
            <Tooltip
              TransitionComponent={Fade}
              TransitionProps={{ timeout: 600 }}
              title={"Vendor Invoice Exist"}
              arrow
              placement="top"
            >
              <PostAddIcon style={{ fill: "rgb(14 126 209)" }} />
            </Tooltip>
          ) : (
            <PostAddIcon color="disabled" />
          )}
        </ListItemIcon>
      );
    },
  },
];
export default function PrintVendorChecks() {
  const dispatch = useDispatch();

  const orderStatuses: any = useAppSelector(selectOrderStatus);

  const [loader, setLoader] = React.useState(false);
  const [ordersData, setOrdersData] = React.useState<GridRowModel[]>([]);
  const [selectedOrders, setSelectedOrders] = React.useState<any>([]);

  React.useEffect(() => {
    dispatch(getOrderStatusAction());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const formik = useFormik({
    initialValues: {
      woStatus: "",
      poNum: "",
      locNum: "",
      beginDate: moment().subtract(1, "months").format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    },
    onSubmit: (values) => {
      alert(JSON.stringify(values, null, 2));
    },
  });

  const { values, setValues } = formik;

  const handleSearch = async () => {
    const { woStatus, beginDate, endDate, locNum, poNum } = values;
    const body = {
      wOStatus: woStatus || "",
      onsiteStartDate: beginDate || null,
      onsiteEndDate: endDate || null,
      locationNum: locNum || "",
      pONum: poNum || null,
    };
    setOrdersData([]);
    setSelectedOrders([]);
    setLoader(true);
    try {
      const results: any = await dispatch(
        searchData("/get-order-by-vendor-num", JSON.stringify(body))
      );

      if (results?.vendors) {
        const transformedData = results.vendors.map((invoice: any) => {
          let conbine = invoice.city;
          if (conbine && invoice.state) conbine = `${conbine}, ${invoice.state}`;
          else if (invoice.state) conbine = invoice.state;
          return {
            ...invoice,
            id: invoice.ocdId,
            city_state: conbine,
            workDate: setDateTimeFormate(invoice.workDate, "YYYY-MM-DDTHH:mm"),
          };
        });
        setOrdersData(transformedData);
      }
    } catch (error) {
      setLoader(false);
    }

    setLoader(false);
  };
  const handleCheckboxSelection = ({ selectionModel }: any) => {
    if (!ordersData.length && !selectionModel.length) {
      return setSelectedOrders([]);
    }
    const selectedRec = ordersData.filter(({ id }) => selectionModel.includes(id));
    setSelectedOrders(selectedRec);
  };
  const onSelectedAll = (isSelected: boolean) => {
    if (isSelected && ordersData.length) {
      return setSelectedOrders(ordersData);
    } else {
      return setSelectedOrders([]);
    }
  };
  const exportExcel = async () => {
    setLoader(true);
    const clone: any[] = [];
    ordersData.map((item: any) => {
      clone.push({
        workDate: item.workDate,
        nte: moneyformatter(item.nte),
        poNum: item.poNum,
        company: item.company,
        location: item.location,
        city: item.city,
        state: item.state,
        orderType: item.orderType,
        orderStatus: item.orderStatus,
        clientPO: item.clientPO,
      });
    });
    await dispatch(downloadFile("export-order-by-vendor-excel", { ordersList: clone }));
    setLoader(false);
  };

  const sendWOEmail = async () => {
    setLoader(true);
    const newListPoNumbers: any = [];
    const newListIds: any = [];
    selectedOrders?.map((item: any) => {
      newListPoNumbers.push(item.poNum);
      newListIds.push(item.ocdId);
    });
    const body = {
      crewDetailIds: newListIds || [],
      vendorPONumbers: newListPoNumbers || [],
      actionType: 2,
      timezone: getTimezoneName(),
      documentId: -1,
      callSource: "vendorportal",
    };
    dispatch(
      sendEmailRequest(
        "/print-work-order-by-crew-detail-id",
        JSON.stringify(body),
        "Email will be sent to you shortly."
      )
    );
    setLoader(false);
  };
  const { height } = UseWindowDimensions();
  let gridMaxHeight = 0;
  const dppr = 1000;
  gridMaxHeight = height - 350;
  return (
    <>
      <CommonDataGridPage
        module={"Work Orders"}
        heading={"List Of Work Orders"}
        GridDataComp={
          <CommonXGrid
            defaultPerPageRecord={dppr}
            rows={ordersData}
            columns={columns}
            height={gridMaxHeight}
            loader={loader}
            checkboxSelection
            //onRowSelection={handleSelectOrder}
            onSelectionModelChange={handleCheckboxSelection}
            onSelectedAll={onSelectedAll}
          />
        }
      >
        <>
          <Grid spacing={2} container direction="row">
            <Grid item xs={12} md={2}>
              <CommonTextFieldDate
                label={"Onsite Begin Date"}
                type={"date"}
                name={"beginDate"}
                value={formik.values.beginDate}
                onChange={formik.handleChange}
                maxDate={formik.values.endDate}
                minDate={moment().subtract(3, "months").format("YYYY-MM-DD")}
                required
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <CommonTextFieldDate
                label={"Onsite End Date"}
                type={"date"}
                name={"endDate"}
                value={formik.values.endDate}
                onChange={formik.handleChange}
                minDate={formik.values.beginDate}
                required
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <CommonAutoCompleteField
                label="WO Status"
                optionsType={orderStatuses}
                getOptionLabel={(option: any) => option.code || null}
                onChange={(row: any) => setValues({ ...values, woStatus: row?.code || "" })}
                value={
                  orderStatuses.find(
                    (val: any) => val?.code && val.code === formik.values.woStatus
                  ) || null
                }
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <CommonTextField
                label="Location Id"
                onChange={formik.handleChange}
                name="locNum"
                value={formik.values.locNum}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <CommonTextField
                label="PO #"
                onChange={formik.handleChange}
                name="poNum"
                value={formik.values.poNum}
              />
            </Grid>
            <Grid item xs={12} md={2} direction="row">
              <Box textAlign="right" mt={0} mb={0}>
                <CommonButton onClick={() => setValues(formik.initialValues)}>Reset</CommonButton>
                <CommonButton isGreen onClick={handleSearch}>
                  Search
                </CommonButton>
              </Box>
            </Grid>
            <Grid item xs={12} md={12} direction="row">
              <Box textAlign="right" mt={-1} mb={1}>
                <CommonButton isGreen onClick={sendWOEmail} disable={selectedOrders?.length < 1}>
                  Email Selected POs
                </CommonButton>
                <CommonButton isGreen disable={ordersData?.length < 1} onClick={exportExcel}>
                  Export all POs to Excel
                </CommonButton>
              </Box>
            </Grid>
          </Grid>
        </>
      </CommonDataGridPage>
    </>
  );
}
